import { SharedDialog } from '../../../common/SharedDialog';

interface DeleteSurveyDialogProps {
  surveyName: string;
  isPermanentDelete: boolean;
  isOpen: boolean;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteSurveyDialog = ({
  surveyName,
  isPermanentDelete,
  isOpen,
  isDeleting,
  onConfirm,
  onCancel,
}: DeleteSurveyDialogProps) => {
  return (
    <SharedDialog
      mode="confirm"
      ariaLabel="Delete RFI"
      isOpen={isOpen}
      onClose={onCancel}
      title="Delete RFI?"
      description={isPermanentDelete
        ? `Are you sure you want to permanently delete "${surveyName}"? This inactive placeholder row will be removed from the database.`
        : `Are you sure you want to delete "${surveyName}"? This will deactivate the RFI.`}
      primaryAction={{
        label: isDeleting ? 'Deleting…' : (isPermanentDelete ? 'Delete Permanently' : 'Delete'),
        intent: 'danger',
        disabled: isDeleting,
        onClick: onConfirm,
        ariaLoadingLabel: isPermanentDelete ? 'Permanently deleting RFI' : 'Deleting RFI',
      }}
      secondaryAction={{ label: 'Cancel', variant: 'outline', disabled: isDeleting, onClick: onCancel }}

    />
  );
};
